import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './utor/contact-us/contact-us.component';

const routes: Routes = [
  {path:'',loadChildren:()=>import('./utor/utor.module').then(m=> m.UtorModule)},
 

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
